export interface LoadAabb {
  x: number;
  y: number;
  z: number;
  width: number;
  length: number;
  height: number;
}

/** Scene units are centimetres × 100. Half a centimetre of contact does not count as a hit. */
export const LOAD_OVERLAP_SLACK = 50;

export function loadAabbsOverlap(a: LoadAabb, b: LoadAabb, slack = LOAD_OVERLAP_SLACK): boolean {
  if (![a.width, a.length, a.height, b.width, b.length, b.height].every((value) => value > 0)) {
    return false;
  }
  return (
    a.x < b.x + b.width - slack &&
    a.x + a.width > b.x + slack &&
    a.y < b.y + b.height - slack &&
    a.y + a.height > b.y + slack &&
    a.z < b.z + b.length - slack &&
    a.z + a.length > b.z + slack
  );
}
